/* eslint-disable eqeqeq */
/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useState } from "react";
import { Card, Col, InputGroup, Row } from "react-bootstrap";
import { useNavigate } from "react-router-dom";
import { Button, Table } from "../../components";
import { useAppDispatch, useAppSelector } from "../../redux/Hooks/Hook";
import { AllBookedCourtsList } from "../../redux/Slice/CourtBooking/CourtBookingListSlice";
import DatePicker from "react-multi-date-picker";
import InputIcon from "react-multi-date-picker/components/input_icon";
import { toast } from "react-toastify";

const CustomerCourtBookingList = (props: any) => {
  const { situationType } = props;
  const dispatch = useAppDispatch();
  const navigate = useNavigate();
  const {
    AllBookedCourtsData,
    currentPage,
    rowsPerPage,
    totalPage,
    totalRows,
    errorMessage
  } = useAppSelector((state) => state.bookedCourt);
  const [key, setKey] = useState("");
  const [fromDate, setFromDate] = useState("");
  const [toDate, setToDate] = useState("");
  const [sorting, setSorting] = useState({ column: "", order: "" });
  const [isMounted, setIsMounted] = useState(false);

  const orderColComing = ["startDate", "facilityName", "sportName", "status"];
  const orderColSend = ["startDate", "facility", "sport", "status"];

  if (errorMessage) {
    toast.error(errorMessage.message)
  }

  const orderByColumn = (col: string) => {
    if (orderColComing.includes(col))
      return orderColSend[orderColComing.indexOf(col)];
    else return "";
  };
  const orderCol = orderByColumn(sorting.column);

  const column = [
    {
      Header: "Sr. No",
      accessor: "srNo",
    },
    {
      Header: "Facility Name",
      accessor: "facilityName",
    },
    {
      Header: "Sport Name",
      accessor: "sportName",
    },
    {
      Header: "Start Date",
      accessor: "startDate",
    },
    {
      Header: "Booking Status",
      accessor: "status",
    },
    {
      Header: "Amount",
      accessor: "totalAmount",
    },
  ];

  useEffect(() => {
    if (key.length <= 0)
      dispatch(
        AllBookedCourtsList({
          page: "1",
          key: "",
          fromDate: convertDate(fromDate),
          toDate: convertDate(toDate),
          orderByCol: orderCol,
          orderBy: sorting.order,
          situationType: situationType,
        })
      );
  }, [key]);

  const handleUserInfo = (data: any) => {
    situationType === "current"
      ? navigate("/customer-court-booking-details", { state: data.id })
      : handleInvoice(data.id);
  };

  const NextPage = (nextpage: number) => {
    dispatch(
      AllBookedCourtsList({
        page: nextpage,
        key: key,
        fromDate: convertDate(fromDate),
        toDate: convertDate(toDate),
        orderByCol: orderCol,
        orderBy: sorting.order,
        situationType: situationType,
      })
    );
  };

  const PreviousPage = (prevpage: number) => {
    dispatch(
      AllBookedCourtsList({
        page: prevpage,
        key: key,
        fromDate: convertDate(fromDate),
        toDate: convertDate(toDate),
        orderByCol: orderCol,
        orderBy: sorting.order,
        situationType: situationType,
      })
    );
  };



  const handleInvoice = (id: string) => {
    const invoiceGet: any = AllBookedCourtsData.find((item) => item.id == id);
    window.open("/printing/?type=invoice&prefix=CB&id=" + id + "&hash=" + invoiceGet?.hash, "_blank");
  };

  const convertDate = (date: string) =>
    date?.split("-").reverse().join("-")
      ? date?.split("-").reverse().join("-")
      : "";

  const handleFromDate = (e: any) => {
    setFromDate(e?.format("DD-MM-YYYY"));
  };

  const handleToDate = (e: any) => {
    setToDate(e?.format("DD-MM-YYYY"));
  };

  const handleSearchByDate = () => {
    dispatch(
      AllBookedCourtsList({
        page: "1",
        key: key,
        fromDate: convertDate(fromDate),
        toDate: convertDate(toDate),
        orderByCol: "",
        orderBy: "",
        situationType: situationType,
      })
    );
  };

  const handleClear = () => {
    setKey("");
    setFromDate("");
    setToDate("");
    setSorting({ column: "", order: "" });
    dispatch(
      AllBookedCourtsList({
        page: "1",
        key: "",
        fromDate: "",
        toDate: "",
        orderByCol: "",
        orderBy: "",
        situationType: situationType,
      })
    );
  };

  useEffect(() => {
    if (isMounted) {
      dispatch(
        AllBookedCourtsList({
          page: "1",
          key: key,
          fromDate: convertDate(fromDate),
          toDate: convertDate(toDate),
          orderByCol: orderCol,
          orderBy: sorting.order,
          situationType: situationType,
        })
      );
    } else {
      setIsMounted(true);
    }
  }, [sorting]);

  return (
    <>
      <Card>
        <Card.Body className="pb-0">
          <div className="page-title align-items-center d-flex justify-content-between">
            <Card.Title className="mb-0">Court Booking List</Card.Title>
          </div>
          <Row className="row-mb">
            <Col lg={6}>
              <label className="form-label me-1"> Start Date : </label>
              <DatePicker
                format="DD-MM-YYYY"
                value={fromDate}
                onChange={handleFromDate}
                render={
                  <InputIcon className="form-control form-control-sm h-auto" />
                }
              />
            </Col>
            <Col lg={6} className="position-relative">
              <InputGroup className="align-items-center">
                <label className="form-label me-1"> End Date : </label>
                <DatePicker
                  format="DD-MM-YYYY"
                  value={toDate}
                  onChange={handleToDate}
                  render={
                    <InputIcon className="border-end-0 form-control form-control-sm h-auto" />
                  }
                  minDate={new Date(fromDate?.split("-").reverse().join("-"))}
                />
                <Button
                  onClick={handleSearchByDate}
                  type="button"
                  bname="Go"
                  name="Go-button"
                  id="go-button"
                  className="btn btn-primary btn-sm rounded-1"
                />
              </InputGroup>
              {fromDate || toDate || key ? (
                <div
                  onClick={handleClear}
                  className="btn btn-link position-absolute top-0"
                  style={{ cursor: "pointer", left: "90%" }}
                >
                  Clear
                </div>
              ) : (
                ""
              )}
            </Col>
            <Col lg={1}></Col>
          </Row>
        </Card.Body>
        <div className="table-responsive">
          <Table
            columns={column}
            data={AllBookedCourtsData}
            hideEditAction={true}
            hideViewAction={true}
            hideDeleteAction={true}
            currentPage={currentPage}
            rowsPerPage={rowsPerPage}
            totalPage={totalPage}
            totalRows={totalRows}
            NextPage={NextPage}
            PreviousPage={PreviousPage}
            show={true}
            isSorting={true}
            sorting={sorting}
            setSorting={setSorting}
            orderColComing={orderColComing}
            onRowClick={handleUserInfo}
            hideActionCol={true}
          />
        </div>
      </Card>
    </>
  );
};

export { CustomerCourtBookingList };
